export const merchantCompanyMutations = {
  setAllmerchantCompanys(state, payload) {
    state.allmerchantCompanys = payload;
  },
  setSelectedMerchantCompany(state, payload) {
    state.selectedMerchantCompany = payload;
  },
};
